import { c as _c } from "react-compiler-runtime";
import { SkeletonView } from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MeetingDetailsSkeleton = () => {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "140px",
      blockSize: "18px",
      borderRadius: "100"
    });
    t1 = /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "70%",
      blockSize: "22px",
      borderRadius: "100"
    });
    t2 = /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "50%",
      blockSize: "14px",
      borderRadius: "100"
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "300",
          children: [t0, t1, t2, /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            gap: "200",
            marginBlockStart: "100",
            children: [0, 1, 2].map(_temp)
          })]
        })
      })
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export const RecordingCardSkeleton = t0 => {
  const $ = _c(7);
  const {
    hasVideo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "120px",
      blockSize: "18px",
      borderRadius: "100"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = hasVideo ? "280px" : "48px";
  let t3;
  if ($[1] !== t2) {
    t3 = /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "100%",
      blockSize: t2,
      borderRadius: "200"
    });
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "center",
      gap: "400",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "32px",
        blockSize: "32px",
        borderRadius: "full"
      }), /*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "40px",
        blockSize: "40px",
        borderRadius: "full"
      }), /*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "32px",
        blockSize: "32px",
        borderRadius: "full"
      })]
    });
    t5 = /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "100%",
      blockSize: "8px",
      borderRadius: "100"
    });
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3) {
    t6 = /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "300",
          children: [t1, t3, t4, t5]
        })
      })
    });
    $[5] = t3;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export const RecapCardSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        marginBlockEnd: "300",
        children: [/*#__PURE__*/_jsx(SkeletonView, {
          inlineSize: "60px",
          blockSize: "16px",
          borderRadius: "100"
        }), /*#__PURE__*/_jsx(SkeletonView, {
          inlineSize: "90px",
          blockSize: "16px",
          borderRadius: "100"
        }), /*#__PURE__*/_jsx(SkeletonView, {
          inlineSize: "40px",
          blockSize: "16px",
          borderRadius: "100"
        })]
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs(CardWrapper, {
      children: [t0, /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "200",
          children: [/*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "100%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "95%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "85%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "100%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "70%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "90%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "80%",
            blockSize: "14px",
            borderRadius: "100"
          }), /*#__PURE__*/_jsx(SkeletonView, {
            inlineSize: "60%",
            blockSize: "14px",
            borderRadius: "100"
          })]
        })
      })]
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(i) {
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "200",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "24px",
      blockSize: "24px",
      borderRadius: "full"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "120px",
      blockSize: "14px",
      borderRadius: "100"
    })]
  }, i);
}